export const DEFAULT_TAB = 'columns';

export enum TabId {
    INPUTS = 'INPUTS',
    OUTPUTS = 'OUTPUTS',
    MODELS = 'MODELS'
}

export enum ProjectTabId {
    INPUT_TABLES = 'INPUT_TABLES',
    INPUT_VIEWS = 'INPUT_VIEWS',
    OUTPUT_EMAILS = 'OUTPUT_EMAILS',
    OUTPUT_GOOGLE = 'OUTPUT_GOOGLE',
    OUTPUT_MODELS = 'OUTPUT_MODELS',
    OUTPUT_TABLES = 'OUTPUT_TABLES',
    OUTPUT_VIEWS = 'OUTPUT_VIEWS'
}

export enum InspectorTabId {
    TRANSFORM = 'TRANSFORM',
    INFO = 'INFO',
    TAGS = 'TAGS',
    JOBS = 'JOBS',
    SETTINGS = 'SETTINGS'
}
